<!-- 数据曲线 -->
<template>
    <div class="chart" ref="chart" v-if="nodeid"></div>
</template>

<script>
/**
 * 用于显示实时曲线
 */
import echarts from 'echarts'
import { formatDate } from '../../../common/util.js'
export default {
    name: 'realchart',
    props: {
        nodeid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            chart: null,
            option: null,
            node: null,
            interval: null,
            labels: [],
            values: []
        }
    },
    destroyed() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    },
    methods: {
        loadData() {
            if (!this.chart) {
                this.chart = echarts.init(this.$refs.chart)
            }
            this.chart.clear()
            this.chart.showLoading()
            // 加载设备的数据
            this.$request('history', 'data', {
                rows: 50,
                page: 1,
                nodeid: this.nodeid
            }).then(res => {
                if (res.code === 1) {
                    let labels = res.data.rows.map(t => t.ReportTime)
                    labels.reverse()
                    this.labels = labels
                    let values = res.data.rows.map(t => t.Value)
                    values.reverse()
                    this.values = values
                    this.node = res.data.node
                    this.initOption()
                    this.chart.setOption(this.option)
                }
                this.chart.hideLoading()
                this.autoRefresh()
            })
        },
        initOption() {
            this.option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{c}' + this.node.Unit + '<br/>{b}'
                },
                grid: {
                    top: '5%',
                    bottom: '15%',
                    left: '5%',
                    right: '5%'
                },
                calculable: true,
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: this.labels,
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 'auto', // 设置为 1，表示『隔一个标签显示一个标签』
                            margin: 15,
                            textStyle: {
                                color: '#4c647c',
                                fontStyle: 'normal',
                                fontSize: 12
                            },
                            formatter: function(params, index) {
                                return formatDate(params, 'hh:mm:ss')
                            }
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#4c647c',
                                opacity: 0.2
                            }
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: false,
                            lineStyle: {
                                color: '#eaeaea'
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        splitNumber: 5,
                        min: this.node.DataMin,
                        max: this.node.DataMax,
                        axisLabel: {
                            textStyle: {
                                color: '#4c647c',
                                fontStyle: 'normal',
                                fontSize: 12
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#eaeaea'
                            }
                        }
                    }
                ],
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        // symbol: 'circle',
                        symbolSize: 5,
                        showSymbol: true,
                        lineStyle: {
                            normal: {
                                width: 2
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: 'rgba(71, 193, 168, 0.3)'
                                        },
                                        {
                                            offset: 0.8,
                                            color: 'rgba(71, 193, 168, 0)'
                                        }
                                    ],
                                    false
                                ),
                                shadowColor: 'rgba(71, 193, 168, 0.2)',
                                shadowBlur: 10
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#47c1a8',
                                borderColor: '#47c1a8',
                                borderWidth: 2
                            }
                        },
                        data: this.values
                    }
                ]
            }
        },
        autoRefresh() {
            if (this.interval) {
                clearInterval(this.interval)
            }
            this.interval = setInterval(() => {
                this.$request('data', 'node', { nodeid: this.nodeid }).then(
                    res => {
                        if (res.code === 1) {
                            this.labels.push(
                                formatDate(
                                    new Date().getTime(),
                                    'yyyy-MM-dd hh:mm:ss'
                                )
                            )
                            this.values.push(res.data.GuagedValue)
                            if (this.values.length > 50) {
                                this.labels.shift()
                                this.values.shift()
                            }
                            this.initOption()
                            this.chart.setOption(this.option)
                        }
                    }
                )
            }, 10000)
        }
    }
}
</script>
<style lang='less' scoped>
.chart {
    height: 220px;
}
</style>
